import { BrowserRouter } from 'react-router-dom';
import CommonRoutes from './Routes.js';

function App() {
  return (
    <BrowserRouter>
      <CommonRoutes />
    </BrowserRouter>
  );
}

export default App;
